import { render, staticRenderFns } from "./BuyingStation.vue?vue&type=template&id=6ef63efa"
import script from "./BuyingStation.vue?vue&type=script&lang=js"
export * from "./BuyingStation.vue?vue&type=script&lang=js"
import style0 from "./BuyingStation.vue?vue&type=style&index=0&id=6ef63efa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports